import { useMutation } from '@tanstack/react-query';
import { openLootbox } from '../rewardHub.service';
export const useOpenLootbox = ({ onSuccess }) => {
    return useMutation({
        mutationFn: (type) => openLootbox(type),
        onSuccess: data => {
            onSuccess(data.prizeInCents);
        },
    });
};
